import { Component, Input, ChangeDetectorRef, ContentChild, HostBinding, inject } from '@angular/core';
import { AccordionLazyDirective } from '@shared/directives/accordion-lazy.directive';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-info-accordion-content',
  styleUrls: ['./info-accordion-content.component.scss'],
  templateUrl: './info-accordion-content.component.html',
  imports: [NgTemplateOutlet],
})
export class InfoAccordionContentComponent {
  private cd = inject(ChangeDetectorRef);

  @ContentChild(AccordionLazyDirective, { static: true })
  lazyContent: AccordionLazyDirective;

  @Input() _isOpen = false;

  @Input()
  set isOpen(value: boolean) {
    if (this._isOpen !== value) {
      this._isOpen = value;
      this.cd.markForCheck();
    }
  }

  get isOpen() {
    return this._isOpen;
  }

  @HostBinding('class.open-animation')
  get hostOpenClass() {
    return this._isOpen;
  }
}
